import React from 'react';

export type ReviewBadgeStatus = 'pending' | 'in_review' | 'delivered' | 'expired' | 'declined' | 'cancelled';

interface ReviewStatusBadgeProps {
  status: ReviewBadgeStatus;
  label: string;
}

const STATUS_STYLES: Record<ReviewBadgeStatus, string> = {
  pending:   'bg-amber-500/15 text-amber-400 border border-amber-500/20',
  in_review: 'bg-blue-500/15 text-blue-400 border border-blue-500/20',
  delivered: 'bg-green-500/15 text-green-400 border border-green-500/20',
  expired:   'bg-white/5 text-white/30 border border-white/10',
  declined:  'bg-red-500/10 text-red-400 border border-red-500/20',
  cancelled: 'bg-white/5 text-white/30 border border-white/10',
};

/**
 * Pill-shaped status badge for roll review requests.
 *
 * Colour-coded by status:
 * - pending   → amber
 * - in_review → blue
 * - delivered → green
 * - expired   → muted
 *
 * Usage:
 * ```tsx
 * <ReviewStatusBadge status="delivered" label={t('my_reviews.status_delivered')} />
 * ```
 */
export const ReviewStatusBadge: React.FC<ReviewStatusBadgeProps> = ({ status, label }) => {
  return (
    <span
      className={[
        'inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold',
        STATUS_STYLES[status],
      ].join(' ')}
    >
      {label}
    </span>
  );
};
